module.exports = __webpack_public_path__ + "static/media/cop_image.dae0fa3d.svg";